module.exports = __webpack_public_path__ + "img/card-credit.a90bd8fc.svg";